/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ListAccounts200,
  ListAccountsParams,
  Account,
  CreateAccount400OneOf,
  CreateAccountBody,
  UpdateAccountName200,
  UpdateAccountName400,
  UpdateAccountName404,
  UpdateAccountNameBody,
  AddAssetsToAccount400OneOf,
  AddAssetsToAccountBody,
  RemoveAssetFromAccount400OneOf,
  RemoveAssetFromAccountBody,
  GetAccountsBalances200,
  GetAccountsBalancesParams,
  GetAccountsCreditSummary200,
  GetAccountsCreditSummaryParams
} from './schema'



/**
 * Get a collection of Accounts based on provided search criteria.
 * @summary Get Accounts
 */
export const listAccounts = (
    params?: ListAccountsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ListAccounts200>> => {
    return axios.get(
      `/accounts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getListAccountsQueryKey = (params?: ListAccountsParams,) => [`/accounts`, ...(params ? [params]: [])];

    
export type ListAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccounts>>>
export type ListAccountsQueryError = AxiosError<unknown>

export const useListAccounts = <TData = Awaited<ReturnType<typeof listAccounts>>, TError = AxiosError<unknown>>(
 params?: ListAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAccountsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccounts>>> = ({ signal }) => listAccounts(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listAccounts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Create Account
 * @summary Create Account
 */
export const createAccount = (
    createAccountBody: CreateAccountBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Account>> => {
    return axios.post(
      `/accounts`,
      createAccountBody,options
    );
  }



    export type CreateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createAccount>>>
    export type CreateAccountMutationBody = CreateAccountBody
    export type CreateAccountMutationError = AxiosError<CreateAccount400OneOf>

    export const useCreateAccount = <TError = AxiosError<CreateAccount400OneOf>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data: CreateAccountBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccount>>, {data: CreateAccountBody}> = (props) => {
          const {data} = props ?? {};

          return  createAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof createAccount>>, TError, {data: CreateAccountBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Update the display name of an existing account. The account must belong to the authenticated user.

 * @summary Update Account Name
 */
export const updateAccountName = (
    updateAccountNameBody: UpdateAccountNameBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateAccountName200>> => {
    return axios.post(
      `/accounts/update-name`,
      updateAccountNameBody,options
    );
  }



    export type UpdateAccountNameMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccountName>>>
    export type UpdateAccountNameMutationBody = UpdateAccountNameBody
    export type UpdateAccountNameMutationError = AxiosError<UpdateAccountName400 | UpdateAccountName404>

    export const useUpdateAccountName = <TError = AxiosError<UpdateAccountName400 | UpdateAccountName404>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountName>>, TError,{data: UpdateAccountNameBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccountName>>, {data: UpdateAccountNameBody}> = (props) => {
          const {data} = props ?? {};

          return  updateAccountName(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof updateAccountName>>, TError, {data: UpdateAccountNameBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * This endpoint is used to add one or more assets to an existing account. Assets that already exist in the given account will be ignored.

 * @summary Add Assets to Account
 */
export const addAssetsToAccount = (
    addAssetsToAccountBody: AddAssetsToAccountBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Account>> => {
    return axios.post(
      `/accounts/add-assets`,
      addAssetsToAccountBody,options
    );
  }



    export type AddAssetsToAccountMutationResult = NonNullable<Awaited<ReturnType<typeof addAssetsToAccount>>>
    export type AddAssetsToAccountMutationBody = AddAssetsToAccountBody
    export type AddAssetsToAccountMutationError = AxiosError<AddAssetsToAccount400OneOf>

    export const useAddAssetsToAccount = <TError = AxiosError<AddAssetsToAccount400OneOf>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAssetsToAccount>>, TError,{data: AddAssetsToAccountBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addAssetsToAccount>>, {data: AddAssetsToAccountBody}> = (props) => {
          const {data} = props ?? {};

          return  addAssetsToAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof addAssetsToAccount>>, TError, {data: AddAssetsToAccountBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * This endpoint is used to remove one or more assets from an existing account. Assets that do not exist in the given account will be ignored. Asset that have a balance or have transcated will not be removed.

 * @summary Remove Assets from Account
 */
export const removeAssetFromAccount = (
    removeAssetFromAccountBody: RemoveAssetFromAccountBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Account>> => {
    return axios.post(
      `/accounts/remove-assets`,
      removeAssetFromAccountBody,options
    );
  }



    export type RemoveAssetFromAccountMutationResult = NonNullable<Awaited<ReturnType<typeof removeAssetFromAccount>>>
    export type RemoveAssetFromAccountMutationBody = RemoveAssetFromAccountBody
    export type RemoveAssetFromAccountMutationError = AxiosError<RemoveAssetFromAccount400OneOf>

    export const useRemoveAssetFromAccount = <TError = AxiosError<RemoveAssetFromAccount400OneOf>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAssetFromAccount>>, TError,{data: RemoveAssetFromAccountBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAssetFromAccount>>, {data: RemoveAssetFromAccountBody}> = (props) => {
          const {data} = props ?? {};

          return  removeAssetFromAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof removeAssetFromAccount>>, TError, {data: RemoveAssetFromAccountBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Retrieves the balances of account(s).
 * @summary Get Balances
 */
export const getAccountsBalances = (
    params?: GetAccountsBalancesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetAccountsBalances200>> => {
    return axios.get(
      `/accounts/balances`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetAccountsBalancesQueryKey = (params?: GetAccountsBalancesParams,) => [`/accounts/balances`, ...(params ? [params]: [])];

    
export type GetAccountsBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountsBalances>>>
export type GetAccountsBalancesQueryError = AxiosError<unknown>

export const useGetAccountsBalances = <TData = Awaited<ReturnType<typeof getAccountsBalances>>, TError = AxiosError<unknown>>(
 params?: GetAccountsBalancesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountsBalances>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountsBalancesQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountsBalances>>> = ({ signal }) => getAccountsBalances(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getAccountsBalances>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * This endpoint is only available for funds accounts associated with fixed limit card accounts.
 * @summary Get account credit summary
 */
export const getAccountsCreditSummary = (
    params: GetAccountsCreditSummaryParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetAccountsCreditSummary200>> => {
    return axios.get(
      `/accounts/credit-summary`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetAccountsCreditSummaryQueryKey = (params: GetAccountsCreditSummaryParams,) => [`/accounts/credit-summary`, ...(params ? [params]: [])];

    
export type GetAccountsCreditSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountsCreditSummary>>>
export type GetAccountsCreditSummaryQueryError = AxiosError<unknown>

export const useGetAccountsCreditSummary = <TData = Awaited<ReturnType<typeof getAccountsCreditSummary>>, TError = AxiosError<unknown>>(
 params: GetAccountsCreditSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountsCreditSummary>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountsCreditSummaryQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountsCreditSummary>>> = ({ signal }) => getAccountsCreditSummary(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getAccountsCreditSummary>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

